// --- BASE ---
import React from 'react';

// --- INTERFACES ---
import { IErrors, IRequest } from '../../Interfaces';

interface IProps {
	asset?: IRequest | null;
	disabled?: boolean;
	errors: IErrors;
	onChange: (name: string, value: string) => void;
}

// *** FUNCTIONAL COMPONENT ***
const LoginInfo = (props: IProps) => {
	const { asset, disabled = false, errors, onChange }: IProps = { ...props };

	return (
		<fieldset className="mb-3">
			<legend>Login Information</legend>

			<p>Enter required login information.</p>

			<div className="row">
				<div className="col-md-4">
					<div className="mb-3">
						<label
							className="required"
							htmlFor="email">
							Email Address
						</label>
						<input
							className={'form-control' + (errors?.email ?? false ? ' is-invalid' : '')}
							disabled={disabled}
							maxLength={200}
							name="email"
							onChange={(e) => onChange(e.currentTarget.name, e.target.value)}
							placeholder="Email Address"
							value={asset?.email ?? ''}
						/>
						<div className="invalid-feedback">{errors?.email ?? ''}</div>
					</div>
				</div>

				<div className="col-md-4">
					<div className="mb-3">
						<label
							className="required"
							htmlFor="email_confirmation">
							Confirm Email
						</label>
						<input
							className={'form-control' + (errors?.email_confirmation ?? false ? ' is-invalid' : '')}
							disabled={disabled}
							maxLength={200}
							name="email_confirmation"
							onChange={(e) => onChange(e.currentTarget.name, e.target.value)}
							placeholder="Confirm Email Address"
							value={asset?.email_confirmation ?? ''}
						/>
						<div className="invalid-feedback">{errors?.email_confirmation ?? ''}</div>
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-md-4">
					<div className="mb-3">
						<label
							className="required"
							htmlFor="password">
							Password
						</label>
						<input
							className={'form-control' + (errors?.password ?? false ? ' is-invalid' : '')}
							disabled={disabled}
							maxLength={100}
							name="password"
							onChange={(e) => onChange(e.currentTarget.name, e.target.value)}
							placeholder="Password"
							type="password"
							value={asset?.password ?? ''}
						/>
						<div className="invalid-feedback">{errors?.password ?? ''}</div>
					</div>
				</div>

				<div className="col-md-4">
					<div className="mb-3">
						<label
							className="required"
							htmlFor="confirm_password">
							Confirm Password
						</label>
						<input
							className={'form-control' + (errors?.password_confirmation ?? false ? ' is-invalid' : '')}
							disabled={disabled}
							maxLength={100}
							name="password_confirmation"
							onChange={(e) => onChange(e.currentTarget.name, e.target.value)}
							placeholder="Confirm Password"
							type="password"
							value={asset?.password_confirmation ?? ''}
						/>
						<div className="invalid-feedback">{errors?.password_confirmation ?? ''}</div>
					</div>
				</div>
			</div>
		</fieldset>
	);
};

export default LoginInfo;
